"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var AMSLogger = /** @class */ (function () {
    function AMSLogger(logger) {
        this.debug = false;
        this.debug = false;
        this.logger = logger;
    }
    /* istanbul ignore next */
    AMSLogger.prototype.setDebug = function (flag) {
        this.debug = flag;
    };
    AMSLogger.prototype.log = function (logLevel, telemetryEvent, customData) {
        var _a;
        var logData = __assign({ Event: telemetryEvent }, customData);
        /* istanbul ignore next */
        this.debug && console.log(logData);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.logClientSdkTelemetryEvent(logLevel, logData);
    };
    return AMSLogger;
}());
exports.default = AMSLogger;
//# sourceMappingURL=AMSLogger.js.map